import PartyName from 'components/party/PartyName';
import { ShareRateDisplay } from 'pages/invoices/payers/ShareInput';
import { MatterPayerDto } from 'types/matters';

/** A case's payers as the read view lists them: each a contact link with its share, the main payer first. */
export function PayerShareList({ payers }: { payers: MatterPayerDto[] }) {
    return (
        <ul className="m-0 flex w-full list-none flex-col gap-1 p-0">
            {payers.map((payer) => (
                <li key={payer.party.id} className="flex items-center justify-between gap-3">
                    <span className="min-w-0">
                        <PartyName party={payer.party} isLink variant="readonly-other" singleLine />
                    </span>
                    <span className="shrink-0 tabular-nums">
                        <ShareRateDisplay value={payer.shareRate} />
                    </span>
                </li>
            ))}
        </ul>
    );
}
